var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-header',[_vm._v(_vm._s(_vm.title))]),_c('b-card-body',[(_vm.statData)?_c('bar-chart',{attrs:{"chart-data":_vm.statData,"options":_vm.statOpts}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }